<template>
  <QuestionPage title="Where will you retire?">
    <QuestionAnswer
      title='In or around London.'
      class='lt-fyf-answer-london'
      :onSelect='chooseLondon'
    />

    <QuestionAnswer
      title='Elsewhere in the UK.'
      class='lt-fyf-answer-elsewhere'
      :onSelect='chooseElsewhere'
    />
  </QuestionPage>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  methods: {
    ...mapMutations([
      'selectIsInLondon',
      'goToNextPage',
    ]),
    chooseLondon: function () {
      this.selectIsInLondon(true);
      this.goToNextPage();
    },
    chooseElsewhere: function () {
      this.selectIsInLondon(false);
      this.goToNextPage();
    },
  }
};
</script>

<style lang='scss'>
.lt-fyf-answer-london {
  background-image: url('../../assets/q-london.jpg');
}

.lt-fyf-answer-elsewhere {
  background-image: url('../../assets/q-not-london.jpg');
}
</style>
